export default __webpack_public_path__ + "static/media/todo-assignment.ca2773fd.svg";